import { Component } from '@angular/core';
import {environment} from "@environment";

@Component({
    selector: 'app-intellectual-property',
    templateUrl: './intellectual-property.component.html',
    styleUrl: './intellectual-property.component.scss',
    standalone: false
})
export class IntellectualPropertyComponent {
  environment: any = environment;
}
